import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

import { IApplicationState } from '../../types/redux';
import { selectFilters } from '../filters';
import { selectIsAgent } from '../user';

/**
 * Определяет, нужно ли отправлять юзера на форму расплаты за оценку
 * Фича формы расплаты за оценку работает только для поискунов и оценки квартир
 */
export const selectIsDataPayment = (state: IApplicationState) => {
  const { estimationTarget } = selectFilters(state);
  const isAgent = selectIsAgent(state);

  return !isAgent && estimationTarget === EEstimationTargets.flat;
};
